import styled from 'styled-components'
import colors from '../../../assets/colors'

export const FunnelStatisticLegacyStyled = styled.div`
  .card-container {
    text-align: left;
    background-color: ${colors.white};
    padding: 30px 20px;
    min-width: 200px;
    min-height: 448px;
    border-radius: 6px;
    box-shadow: 0 4px 6px rgba(98, 102, 113, 0.06), 0 2px 2px rgba(98, 102, 113, 0.06);
  }
  
  .full{
    width: 100%;
  }
  
  /* Pesos como el resto de estadísticas: título 16/600, datos 14/500 */
  .label-stat {
    text-align: left;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: ${colors.blackAlpha80};
    margin: 0;
    margin-bottom: 20px;
  }
    
  .funnel-title {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    > span:first-child {
      font-size: 16px;
      font-weight: 600;
    }
  }
  
  .extra-data {
    font-size: 13px;
    font-weight: 400;
  }

  .container-info{
    position: relative;
  }

`

const funnel_polygon = ({top, bottom}) => {
  return `polygon(${50 - top/2}% 0, ${top/2  + 50}% 0, ${bottom/2 + 50}% 100%, ${50 - bottom/2}% 100%)`;
}

export const FunnelItem = styled.div`
  max-width: 100%;
  width: 30vmin;
  height: 8vmin;
  background-color: ${props => props.theme.primary+props.opacity};
  clip-path: ${props => funnel_polygon(props)};
  margin-bottom: 1px;
  padding-top: 12%;
  text-align: center;
`

export const FunnelInfo = styled.div`
  position: absolute;
  bottom: 0;
  right: 0; 
  text-align: right;   
  .title{
    color: ${colors.blackAlpha50};
    font-size: 12px;
    font-weight: 400;
    padding-bottom: 3px;
  }
 .value{
    color: ${colors.blackAlpha80};
    font-size: 18px;
    font-weight: 600;
    padding-bottom: 9px;
  }
`
